import './Page.scss'

export default {
	name: "eiis-page",
	data() {
		return {
			drawerOpen: true
		}
	},
	props: {
		header: String, icon: String, footer: String, drawer: Boolean
	},
	methods: {
		toggleDrawer(event) {
			this.drawerOpen = !this.drawerOpen;
		}
	},
  computed: {
		thinDrawer: function() {
			return (this.drawerOpen == false) ? "eiis-thin-drawer": "";
		}
	},
	template: `
		<div class="eiis-page">
			<div class="container-fluid eiis-page-area">
			<div class="eiis-page-header" v-if=header>
				<div class="header-icon" v-bind:class=icon v-if=icon></div>
					{{header}}

				<div class="eiis-page-header-toolbar">
					<slot name="page-header"></slot>	
				</div>
			</div>
			</div>

			<div class="container-fluid eiis-page-area">
				<div class="d-flex">
					<div id="page-drawer" class="eiis-page-drawer" v-bind:class=thinDrawer v-if=drawer>
						<slot name="drawer">slot</slot>	
						<div class="eiis-page-toggle-button fixed-bottom" @click="toggleDrawer">
							<div class="eiis-page-toggle-icon" title="Collapse" v-if=drawerOpen>
								 <i class="fas fa-angle-double-left fa-fw"></i>
							</div>	
							<div class="eiis-page-toggle-icon" title="Expand" v-if=!drawerOpen>
								<i class="fas fa-angle-double-right fa-fw"></i>
							</div>	
						</div>
					</div>
					<div class="eiis-page-content">
						<slot></slot>	
					</div>
				</div>
			</div>

			<div class="eiis-page-footer" v-if=footer>
				{{footer}}
					<slot name="page-footer"></slot>	
				<div class="eiis-page-header-toolbar col-flex justify-content-end align-content-center">
				</div>
			</div>
		</div>
	`
}